import { render, staticRenderFns } from "./ShippmentWithCity.vue?vue&type=template&id=72bd55a8&"
import script from "./ShippmentWithCity.vue?vue&type=script&lang=js&"
export * from "./ShippmentWithCity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\wamp\\www\\laravel\\rawal\\rawal-laravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72bd55a8')) {
      api.createRecord('72bd55a8', component.options)
    } else {
      api.reload('72bd55a8', component.options)
    }
    module.hot.accept("./ShippmentWithCity.vue?vue&type=template&id=72bd55a8&", function () {
      api.rerender('72bd55a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/ShippmentWithCity.vue"
export default component.exports